"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactHighlightWords = _interopRequireDefault(require("react-highlight-words"));

var _Tooltip = _interopRequireDefault(require("@cimpress/react-components/lib/Tooltip"));

var _i18n = require("./i18n");

var _reactI18next = require("react-i18next");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var FulfillmentLocationsListItem =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FulfillmentLocationsListItem, _React$Component);

  function FulfillmentLocationsListItem(props) {
    _classCallCheck(this, FulfillmentLocationsListItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(FulfillmentLocationsListItem).call(this, props));
  }

  _createClass(FulfillmentLocationsListItem, [{
    key: "onSelected",
    value: function onSelected() {
      if (this.props.onClick) {
        this.props.onClick(this.props.location);
      }
    }
  }, {
    key: "highlight",
    value: function highlight(target) {
      if (!this.props.highlight) {
        return target;
      }

      return _react.default.createElement(_reactHighlightWords.default, {
        highlightClassName: "highlight",
        highlightStyle: this.style({
          backgroundColor: "yellow",
          padding: "0px",
          color: "black"
        }),
        searchWords: [this.props.highlight],
        autoEscape: true,
        textToHighlight: target + ''
      });
    }
  }, {
    key: "style",
    value: function style(styles) {
      if (this.props.disableInlineStyles) {
        return undefined;
      }

      return styles;
    }
  }, {
    key: "renderInternalId",
    value: function renderInternalId(id) {
      if (!this.props.showInternalIds) {
        return null;
      }

      return _react.default.createElement("em", {
        className: "text-muted"
      }, "(", this.highlight(id), ")");
    }
  }, {
    key: "renderTitle",
    value: function renderTitle(loc, hasFulfiller) {
      if (this.props.customTitleRenderer) {
        return this.props.customTitleRenderer(loc);
      }

      if (!this.props.onClick) {
        return _react.default.createElement("h5", {
          style: this.style({
            verticalAlign: "middle"
          })
        }, this.props.isRecent ? _react.default.createElement(_Tooltip.default, {
          contents: this.tt("recent-location"),
          direction: "top"
        }, _react.default.createElement("i", {
          className: "fa fa-clock-o"
        })) : _react.default.createElement("i", {
          className: "fa fa-map-marker"
        }), _react.default.createElement("span", null, "\xA0"), hasFulfiller ? _react.default.createElement("span", null, this.highlight(loc.FulfillerName), "\xA0\u2022\xA0") : null, _react.default.createElement("strong", null, this.highlight(loc.FulfillmentLocationName)));
      }

      return _react.default.createElement("h5", {
        onClick: this.onSelected.bind(this),
        style: this.style({
          cursor: "pointer",
          verticalAlign: "middle"
        })
      }, this.props.isRecent ? _react.default.createElement(_Tooltip.default, {
        contents: this.tt("recent-location"),
        direction: "top"
      }, _react.default.createElement("i", {
        className: "fa fa-clock-o"
      })) : _react.default.createElement("i", {
        className: "fa fa-map-marker"
      }), _react.default.createElement("span", null, "\xA0"), _react.default.createElement("a", null, hasFulfiller ? _react.default.createElement("span", null, this.highlight(loc.FulfillerName), "\xA0\u2022\xA0") : null, _react.default.createElement("strong", null, this.highlight(loc.FulfillmentLocationName))));
    }
  }, {
    key: "tt",
    value: function tt(key) {
      var _this$props = this.props,
          t = _this$props.t,
          language = _this$props.language;
      return t(key, {
        lng: language
      });
    }
  }, {
    key: "render",
    value: function render() {
      var loc = this.props.location;
      var hasFulfiller = loc.FulfillerId && loc.FulfillerId != -1;
      var hasFulfillmentLocation = loc.FulfillmentLocationId && loc.FulfillmentLocationId != -1;
      return _react.default.createElement("tr", {
        className: "cimpress-fl-list-item"
      }, _react.default.createElement("td", {
        width: "100%"
      }, this.renderTitle(loc, hasFulfiller)), this.props.showFulfillmentLocationId ? _react.default.createElement("td", {
        style: this.style({
          color: "#333943",
          verticalAlign: "middle"
        })
      }, hasFulfillmentLocation ? _react.default.createElement("span", null, this.highlight(loc.FulfillmentLocationId), "\xA0", this.renderInternalId(loc.InternalFulfillmentLocationId)) : _react.default.createElement("span", null, "\xA0")) : null, this.props.showFulfillerId ? _react.default.createElement("td", {
        style: this.style({
          color: "#333943",
          verticalAlign: "middle"
        })
      }, hasFulfiller ? _react.default.createElement("span", null, this.highlight(loc.FulfillerId), "\xA0", this.renderInternalId(loc.InternalFulfillerId)) : _react.default.createElement("span", null, "\xA0")) : null, this.props.additionalColumnRenderer ? _react.default.createElement("td", {
        style: this.style({
          color: "#333943",
          verticalAlign: "middle",
          textAlign: "center"
        })
      }, this.props.additionalColumnRenderer(loc)) : null);
    }
  }]);

  return FulfillmentLocationsListItem;
}(_react.default.Component);

FulfillmentLocationsListItem.propTypes = {
  onClick: _propTypes.default.func,
  highlight: _propTypes.default.string,
  location: _propTypes.default.object.isRequired,
  disableInlineStyles: _propTypes.default.bool,
  showInternalIds: _propTypes.default.bool,
  showFulfillerId: _propTypes.default.bool,
  showFulfillmentLocationId: _propTypes.default.bool,
  additionalColumnRenderer: _propTypes.default.func,
  customTitleRenderer: _propTypes.default.func,
  isRecent: _propTypes.default.bool,
  language: _propTypes.default.string,
  // silence eslint
  t: _propTypes.default.any,
  i18n: _propTypes.default.any
};
FulfillmentLocationsListItem.defaultProps = {
  disableInlineStyles: false,
  showInternalIds: true,
  showFulfillerId: true,
  showFulfillmentLocationId: true,
  additionalColumnRenderer: undefined,
  customTitleRenderer: undefined,
  isRecent: false,
  language: 'en'
};

var _default = (0, _reactI18next.translate)('translations', {
  i18n: (0, _i18n.getI18nInstance)()
})(FulfillmentLocationsListItem);

exports.default = _default;